import zPage from '../Page/page.vue';
import {removeRichTextLabel,hiddenPhone} from '@/assets/js/tools.js';
export default{
    name:'ProjectCenter',
    data(){
        return{
            imgs:[
                // {
                //     path:'home-img1.png',
                //     title:'标题1',
                // },
                // {
                //     path:'home-img2.png',
                //     title:'标题2',
                // },
                // {
                //     path:'home-img3.png',
                //     title:'标题3',
                // },
            ],
            page1:{
                targetPage:1,
                pageSize:10,
                totalPage:100,
                type:1, 
            },
            deviceType:[],
            device:{},
            productList:[],
        }
    },
    components:{
        zPage,
    },
    created(){
        this.getDeviceType();
        this.getData();
    },
    methods:{
        getDeviceType(){
            this.get(this.api.getDeviceType).then(res=>{
                this.deviceType=res.data;
            }).catch();
        },
        getData(){
            this.imgs=[];
            var body={
                pageNumber:this.page1.targetPage-1,
                pageSize:this.page1.pageSize,
                code:this.device.code,
            };
            this.get(this.api.getProductCenterList,body).then(res=>{
                this.page1.totalPage=res.data.totalElements;
                this.productList=res.data.list;
                for(var i=0;i<this.productList.length;i++){
                    this.imgs.push({id:this.productList[i].id,path:this.productList[i].fgpic,title:this.productList[i].pname});
                    this.productList[i].fgnr=removeRichTextLabel(this.productList[i].fgnr);
                    this.productList[i].phone=hiddenPhone(this.productList[i].phone);
                }
            }).catch();
        },
        clickDevice(item){
            this.device=item;
            this.getData();
        },
        getDetail(id){
            this.$router.push({path:'/productDetail',query:{id:id}});
        },
    }
}